module.exports = __webpack_public_path__ + "8d460f7ea556264cd97009205d058f06.pdf";